import Global from '../../store/global-selectors';
import { StampsWalletDHLService } from '../stamps-wallet-dhl-service';

class DHLTermsAndConditionsServiceClass {
  sellerHasDhlWalletPurchaseAndNotAcceptedTerms(state, fulfillmentPlans) {
    if (!fulfillmentPlans || !fulfillmentPlans.length) {
      return false;
    }
    const labelProviders = Global.selectSellerLabelProviders(state);
    const hasAcceptedDhlWalletTerms = Global.selectSellerHasAcceptedDhlWalletTerms(state);
    if (hasAcceptedDhlWalletTerms) {
      return false;
    }
    const hasDhlFulfillmentPlan = StampsWalletDHLService.hasFulfillmentWithStampsWalletDhlService(labelProviders, fulfillmentPlans);
    return hasDhlFulfillmentPlan && !hasAcceptedDhlWalletTerms;
  }
}

export const DHLTermsAndConditionsService = new DHLTermsAndConditionsServiceClass();
